import axios from "axios";
import {
  SET_GROUPS,
} from "../actions/types";

const BE_URI = process.env.REACT_APP_BE_URI;

const getGroups = async (token, dispatch) => {

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    authorization: `Bearer ${token}`, // should it be authorization?
  };

  const formData = new FormData();
  formData.append('userId', "63bb2de524ba005c04f0f4e0");

  const res = await axios.post(BE_URI + "/getGroupsYouBelongTo",  {"userId": "63bb2de524ba005c04f0f4e0"} , { headers });

  if (res.data.success) {
    
    dispatch({
      type: SET_GROUPS,
      payload: res.data.groups,
    });
  } else {
    console.log("Error fetching groups");
  }
  
};

export default {
  getGroups,
};